import React from "react";
import { useUserInfo } from "@/components/business/user-info-provider";
import DefaultAvatar from "@/assets/avatar.png";
import { ReactComponent as SvgIconLogout } from "@/assets/icon-logout.svg";
import PopoverPlane from "../popover-plane";
import { GLOBAL_KEYS } from "@/configs";
import { setCookieValue } from "@/utils";
import useRouter from "@/hoc/use-router";
import { useTranslation } from "react-i18next";

const UserSettings: React.FC = () => {
  const { t } = useTranslation();
  const { router } = useRouter();
  const { userInfo, clearUserInfo } = useUserInfo();

  const handleLogout = () => {
    clearUserInfo();
    localStorage.removeItem(GLOBAL_KEYS.USER_TOKEN);
    setCookieValue(GLOBAL_KEYS.USER_TOKEN, "");
    router.replace("/login");
  };

  return userInfo ? (
    <PopoverPlane
      className="user-settings"
      content={
        <div className="page-header-dropdown for-user">
          <h3>{userInfo?.nickName || "-"}</h3>
          <p>{userInfo?.email || "-"}</p>
          <div className="dropdown-scroll">
            <div onClick={handleLogout}>
              <span>{t("common_log_out")}</span>
              <SvgIconLogout />
            </div>
          </div>
        </div>
      }
      placement="bottom-end"
    >
      <img src={userInfo?.avatar || DefaultAvatar} alt="avatar" className="avatar" />
    </PopoverPlane>
  ) : null;
};

export default UserSettings;
